import type { FaireProductEntity } from "../../entity_types/product";

export const p_uavgd4t79v: FaireProductEntity = {
  token: "p_uavgd4t79v",
  type: "product",
  name: "Zircon linked18K Gold Plated S.Steel Y-neck Necklace - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/d7ce95dc7fff98676a17f61c6b6251d2254ee87cd8cfb342a594a2f5e52f1838.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/064ff81f8201ececf04e746f8e64173f302f168a2a0b11dcfaa0b8f05b4b10b6.jpeg",
    "https://cdn.faire.com/fastly/14ff1c67941352aa54532c7211c07c2b553ca2f097965665085230f458558084.jpeg",
    "https://cdn.faire.com/fastly/af599f0abc70fcdcce03de941a0d8de6c507af835355d7ae6128b30580b75481.jpeg",
  ],
  priceDollars: 11.04,
  description:
    "Type: Pendant necklace\nMaterial: Stainless steel，Zircon，18K gold plated\nSize of pendant : 5mm*105mm\nLength of chain : 400mm + 50mm\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts\n ",
  tags: [],
  msrpDollars: 27.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:24.648Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
